// @flow
export const isExternal = (location: any) =>
  location.type === 'auxiliary-offstreet' ||
  location.type === 'auxiliary-onstreet';

export const isJp = (location: any) =>
  ['justpark', 'enquiry', 'driveup', 'driveup-onstreet'].indexOf(
    location.type
  ) !== -1;

export const isDriveup = (location: any) =>
  ['driveup', 'driveup-onstreet'].indexOf(location.type) !== -1;

export const isReservable = (location: any) =>
  ['justpark', 'enquiry'].indexOf(location.type) !== -1;

export default {
  isJp,
  isExternal
};
